import { em } from 'polished'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: center;

  ${p => p.theme.mq.upMd} {
    flex-wrap: nowrap;
  }
`

export const IconBox = styled.div`
  margin-left: ${em(10)};
  margin-right: ${em(10)};
  margin-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    margin-left: ${em(20)};
    margin-right: ${em(20)};
  }

  ${p =>
    p.id === 'pci' &&
    css`
      width: ${em(41)};
      height: ${em(28)};
      margin-left: 0;
    `}

  ${p =>
    p.id === 'norton' &&
    css`
      width: ${em(65)};
      height: ${em(28)};
    `}

  ${p =>
    p.id === 'verify' &&
    css`
      width: ${em(50)};
      height: ${em(29)};
    `}

  ${p =>
    p.id === 'secure' &&
    css`
      width: ${em(58)};
      height: ${em(21)};
      margin-right: 0;
    `}
`
